import React, { FC, useEffect, useState } from 'react';
import { SelectProps, SelectValue } from 'antd/lib/select';
import { RcFile } from 'antd/lib/upload';

import { CreateTag } from '../CreateTag';
import { IPOMessage, IPOTag } from '../../../index';

import { Divider, Input, Select, ModalProps } from 'antd';
import { TagSelectWrap, UserSelectView } from './style';

type Props = {
	dataList: IPOTag.IListTag[]; //数据列表，你来控制添加/数据格式
	createTag?: (data: IPOTag.IAddTag) => void; //返回表单添加到数据
	disabledAdd?: boolean;
	upFile?: (
		file: RcFile,
		FileList: RcFile[],
	) => Promise<void | {
		id: string;
		url: string;
	}>; //返回上传到文件，你需要返回id或者icon地址
	addTagProps?: ModalProps;
} & SelectProps<SelectValue>;
export const SelectTag: FC<Props> = ({
	dataList,
	upFile,
	createTag,
	disabledAdd = false,
	addTagProps,
	...selectProps
}) => {
	const [searchVal, setSearchVal] = useState<string>('');
	const [visible, setVisible] = useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);
	
	useEffect(() => {
		setVisible(false);
	}, []);
	const onCancel = (data?: IPOTag.IAddTag) => {
		setVisible(false);
		if (data && createTag) {
			createTag(data);
		}
	};
	const { onDropdownVisibleChange, ...nowSelectProps } = selectProps;
	return (
		<TagSelectWrap>
			<Select
				searchValue={searchVal}
				mode="multiple"
				style={{ width: '100%' }}
				open={open && !disabledAdd}
				onClick={() => {
					if(disabledAdd) {
						IPOMessage.warning('您未连接到中心服务器无权限更改标签！')
					}
				}}
				optionFilterProp="label"
				onDropdownVisibleChange={e => {
					if (!e && !visible) {
						setVisible(false);
						setSearchVal('');
					}
					!visible && setOpen(e);
					onDropdownVisibleChange && onDropdownVisibleChange(e);
				}}
				dropdownRender={dom => (
					<UserSelectView>
						<Input.Search
							width={'90%'}
							className="margin-view"
							value={searchVal}
							onChange={e => setSearchVal(e.target.value)}
						/>
						{upFile && (
							<div className="margin-view add-text" onClick={() => setVisible(true)}>
								添加新标签
							</div>
						)}
						<Divider style={{ margin: '5px 0' }} />
						{dom}
						{visible && upFile && <CreateTag {...addTagProps} upFile={upFile} onClose={onCancel} />}
					</UserSelectView>
				)}
				{...nowSelectProps}>
				{dataList.map(item => (
					<Select.Option key={item.id} label={item.name} value={item.id}>
						{item.name}
					</Select.Option>
				))}
			</Select>
		</TagSelectWrap>
	);
};
